import { Link } from 'ice';
import { FrownOutlined } from '@ant-design/icons';

const Error = () => (
  <div
    className="content-inner"
    style={{
      padding: 20,
    }}
  >
    <div className="error-page">
      <FrownOutlined />
      <p>1.该页面不存在或路由异常</p>
      <p>2.您没有相应的访问权限</p>
      <h1>
        <Link to="/index">返回主页</Link>
      </h1>
    </div>
  </div>
);

export default Error;
